const data = [
   
    {
        name:'Air conditioners',
        img:'',
        iconSource:"",
        subcategory:[
            {
                name:"Foor Standing",
                img:"",
            },
            {
                name:"Split Ac",
                img:""
            },
            {
                name:"Split Ac Inventor",
                img:""
            },

            {
            name:"Wall Bracket",
            img:""
            }
        ]
    },
    {
        name:"Dish Washer",
        img:"",
        subcategory:[
            {
                name:"Automatic",
                img:""
            }
        ]
    },
    {
        name:"Kitchen Appliances",
        img:"",
        subcategory:[
            {
                name:"Electric Cooker",
                img:""
            },
            {
                name:"Blenders",
                img:""
            },
            {
                name:"Chppers",
                img:""
            },
            {
                name:"Gas Cooker",
                img:""
            },
            {
                name:"Kettle",
                img:""
            },
            {
             name:"Microwave Ovens",
             img:""
            }
        ]
    },
    {
        name:"Refrigerators",
        img:"",
        subcategory:[
            {
                name:"Chest Freezer",
                img:""
            },
            {
                name:"Crose Door",
                img:""
            },
            {
                name:"Double Door",
                img:""
            },
            {
                name:"Single Door",
                img:""
            },
            {
                name:"Table top",
                img:""
            },
            {
                name:"Showcase fridge",
                img:""
            },
            {
                name:"Upright Freezer",
                img:""
            },
            {
                name:"Side-By-Side"
            }
        ]
    },

    {
        name:"Sound Systems",
        img:"",
        subcategory:[
            {
                name:"Audio Speakers",
                img:""
            },
            {
                name:"Tv Speakers",
                img:""
            },
            {
                name:"Portables",
                img:""
            },
            {
                name:"Headphones",
                img:""
            }
        ]
    },
    {
        name:"Televition",
        img:"",
        subcategory:[
            {
                name:"Tv Wall Bracket",
                img:""
            },
            {
                name:"TV'40",
                img:''
            },
            {
                name:"TV'100",
                img:''
            },
            {
                name:"TV'45",
                img:''
            },
            {
                name:"TV'35",
                img:''
            },
            {
                name:"TV'70",
                img:''
            },
            {
                name:"TV'75",
                img:''
            },
            {
                name:"TV'80",
                img:''
            },
            {
                name:"TV'85",
                img:''
            },
            {
                name:"TV'80",
                img:''
            },
            {
                name:"TV'50",
                img:''
            },
            {
                name:"TV'55",
                img:''
            },
            {
                name:"TV'58",
                img:''
            },
            {
                name:"TV'78",
                img:''
            },
            {
                name:"TV'32",
                img:''
            },
           
        ]
    },

    {
        name:"Washing Machine",
        img:"",
        subcategory:[
            {
                name:"Automatic Washing Machine",
                img:""
        },
        {
            name:"Twin Tub Washing ",
            img:""
        },
        {
            name:"Frontload Washing Machine",
            img:""
        }
        ]
    },
    {
        name:"Water Dispenser",
        img:"",
        subcategory:[
            {
                name:"Top loading ",
                img:""
            },
            {
                name:"Bottom Loading",
                img:""
            }
        ]
    },
    {
        name:"Accessaries And Appliances",
        img:"",
        subcategory:[
            {
                name:"Power",
                img:""
            },
            {
                name:"Light",
                img:""
            },
            {
                name:"Home",
                img:""
            },
            {
                name:"OutDoor",
                img:""
            },
            {
                name:"Digital Tv Antena",
                img:""
            },
            {
                name:"HDMI Cable",
                img:""
            }

        ]
    }
   
]


const megadata =
    { 
        data:{
           
           
            listSubCategory:[{
                name:"floor standing gooo",
                iconSource:"https://hisense2-myapptino-assets.s3.eu-west-2.amazonaws.com/app_assets/product_images/Hisense/212/Images_515x512_80.jpg",
                
                  categoryId:{
                     majorCategoryId:{
                        name:"floor standing beter",
                        iconSource:"https://hisense2-myapptino-assets.s3.eu-west-2.amazonaws.com/app_assets/product_images/Hisense/212/Images_515x512_80.jpg",

                    }
                    ,
                    
                },
            },
            {  name:"floor standing",
            iconSource:"https://hisense2-myapptino-assets.s3.eu-west-2.amazonaws.com/app_assets/product_images/Hisense/212/Images_515x512_80.jpg",
            categoryId:1,},
            {  name:"floor standin",
            iconSource:"https://hisense2-myapptino-assets.s3.eu-west-2.amazonaws.com/app_assets/product_images/Hisense/212/Images_515x512_80.jpg",
            categoryId:1,},
            {  name:"floor standino",
            iconSource:"https://hisense2-myapptino-assets.s3.eu-west-2.amazonaws.com/app_assets/product_images/Hisense/212/Images_515x512_80.jpg",
            categoryId:1,}
        ],
           
                   },
        
         
        }
export default megadata